import { HttpClient } from '@sdir/httpclient/lib/HttpClient';
import {
  PersonalCertificateVerifyApi,
  SeafarerIdentityDocumentApi,
} from '@sdir/httpclient/lib/clients/aps/personalcertificate';
import { InternalApi } from '@sdir/httpclient/lib/clients/aps/endorsement';
import { MedicalCertificateApi } from '@sdir/httpclient/lib/clients/aps/health';
import { InternalApi as DispensationApi } from '@sdir/httpclient/lib/clients/aps/dispensation';
import { DEFAULT_LANG, getCurrentLanguageOutsideProvider } from '../helpers/languageHelpers';

const clientId = 'verify';
const authority = process.env.REACT_APP_EXTERNALAUTHURL || '';
const baseUrl = process.env.REACT_APP_API_URL;
const httpClient = new HttpClient(baseUrl);

httpClient.addAPIMSubscriptionKeyHeader(process.env.REACT_APP_SUBSCRIPTIONKEY);
httpClient.addOICDAuthorizationHeader(authority, clientId);
httpClient.addRequestMiddleware((req) => {
  const currentLang = getCurrentLanguageOutsideProvider();
  req.headers = {
    ...req.headers,
    'Accept-Language': req.headers?.['Accept-Language'] || currentLang || DEFAULT_LANG,
  };
  return req;
});

export const personalCertificateVerifyApi = new PersonalCertificateVerifyApi(
  undefined,
  `${baseUrl}/aps-personalcertificate-internal`,
  httpClient.client
);

export const sidVerifyApi = new SeafarerIdentityDocumentApi(
  undefined,
  `${baseUrl}/aps-personalcertificate-internal`,
  httpClient.client
);

export const dispensationApi = new DispensationApi(
  undefined,
  `${baseUrl}/aps-dispensation-internal`,
  httpClient.client
);

export const endorsementApi = new InternalApi(
  undefined,
  `${baseUrl}/aps-endorsement-internal`,
  httpClient.client
);

export const medicalExaminationApi = new MedicalCertificateApi(
  undefined,
  `${baseUrl}/aps-health-internal`,
  httpClient.client
);
